import { Loading } from 'element-ui';
 
let loadingCount = 0;
let loading;
 
const startLoading = () => {
  loadingCount = 0;
  // endLoading();
  // loading = Loading.service({
  //   lock: true,
  //   text: '加载中……',
  //   background: 'rgba(255, 255, 255, 0.3)',
  //   target: document.querySelector('.loading') // 设置加载动画区域
  // });
};
 
const endLoading = () => {
  // loading.close();
};
 
export const showLoading = () => {
  // if (loadingCount === 0) {
  //   startLoading();
  //   loadingCount += 1;
  // }

};
 
export const hideLoading = (val) => {
  // if (loadingCount <= 0) {
  //   loadingCount = 0
  //   loading.close();
  //   return endLoading();;
  // }
  // loadingCount -= 1;
  // if (val === 0) {
  //   loadingCount = 0
  //   endLoading();
  
  // }
};